// extracted by mini-css-extract-plugin
module.exports = {"container":"AuthInput_container__1_P-p","error":"AuthInput_error__374Xs","label":"AuthInput_label__3wgCz","input":"AuthInput_input__1JaNM"};